import imagesLoaded from 'imagesloaded'

export default () => {
    
    const tags = document.querySelectorAll('.read-artwork')
    const bodyTag = document.querySelector('body')
    bodyTag.classList.add('transition')

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            let previousHex = bodyTag.style.backgroundColor
            if ( entry.intersectionRatio > 0.5 && entry.intersectionRatio < 0.6 ) {
                let newHex = entry.target.getAttribute('data-rgb')
                bodyTag.style.backgroundColor = newHex
            } else {
                bodyTag.style.backgroundColor = previousHex
            }
        })

    }, {
        threshold: [0, 0.1, 0.5 , 1],
        rootMargin: '30px',
    })
    
    tags.forEach(tag => {
        observer.observe(tag)
    })
}

